import { ParentDashboard } from './ParentDashboard';

export function ParentProgressPage() {
  return <ParentDashboard initialTab="progress" />;
}
